import React, { useMemo, useState } from 'react';
import { SIZE, StyledDivider } from 'baseui/divider';
import { useAtomValue } from 'jotai';
import { completedAnnotationsAtom, reviewAnnotationsAtom } from '../atoms';
import { FILTER_OPTIONS } from '../constants';
import { QuestionMarkIcon } from '../icons/question-mark-icon';
import { PanelStateRenderer } from '../panel-state-renderer';
import { SearchBar } from '../search-bar';
import { PanelContainer, PanelHeader, SectionHeader, StyledHeading } from '../styled-component-overrides';
import type { CompletedAnnotationT, ReviewAnnotationT } from '../types';
import { CardList } from './card-list';
type Props = {
  selectAnnotation?: (annotationId: string) => void;
};
export const CompletedPanel = ({
  selectAnnotation
}: Props) => {
  const [selectedFilterIndex, setSelectedFilterIndex] = useState<number>(0);
  const reviewAnnotations = useAtomValue(reviewAnnotationsAtom);
  const completedAnnotations = useAtomValue(completedAnnotationsAtom);
  const handleFilterChange = (value: string) => {
    const index = FILTER_OPTIONS.findIndex(option => option.id === value);
    if (index !== -1) {
      setSelectedFilterIndex(index);
    }
  };
  const filteredAnnotations = useMemo<(ReviewAnnotationT & CompletedAnnotationT)[]>(() =>
  // @ts-expect-error todo(ts-migration) TS2322 Type '{ annotationId: string; status: ReviewAnnotationStatusT; type?: ReviewAnnotationTypeT | undefined; name?: string | undefined; instances?: ReviewAnnotationInstanceT[] | undefined; attributes?: Re...
  completedAnnotations.filter(({
    status
  }) =>
  // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
  selectedFilterIndex === 0 || status === FILTER_OPTIONS[selectedFilterIndex].id).map(({
    annotationId,
    status
  }) => ({
    ...reviewAnnotations[annotationId],
    annotationId,
    status
  })), [completedAnnotations, selectedFilterIndex, reviewAnnotations]);
  if (completedAnnotations.length === 0) {
    return <PanelStateRenderer icon={<QuestionMarkIcon />} title="No labels to show" description="Accept/Reject labels to see them here. You can also revert them to pending if needed." />;
  }
  return <PanelContainer>
      <PanelHeader>
        <SectionHeader>
          <StyledHeading>Objects</StyledHeading>
        </SectionHeader>
        <SearchBar placeholder="Category" options={FILTER_OPTIONS} currentValueIndex={selectedFilterIndex} onChange={handleFilterChange} />
      </PanelHeader>

      <StyledDivider $size={SIZE.cell} $style={{
      width: '100%',
      margin: '16px 0'
    }} />

      <CardList annotations={filteredAnnotations} selectAnnotation={selectAnnotation} />
    </PanelContainer>;
};